import { forEach } from 'lodash';
import {
    customGridAddSkuData,
    customGridDataWarehouseLabel,
    customPickGridConfig,
    customFinalizedGridConfig,
} from '../fulfillments/helpers';

export const updateCustomGridData = (app, routes, customGridData) => {
    forEach(routes, (routeName) => {
        const route = app.routes.getItem(routeName);
        if (route) {
            const routeProps = route.props;

            route.props = (state) => ({
                ...routeProps(state),
                customGridData,
            });
            app.routes.changeItem(routeName, route);
        }
    });
};

export default {
    name: 'skuFilterInFulfillments',
    before: [],
    after: [],
    setup: (app) => {
        const skuRoutes = [
            'fulfillmentShipCancelled',
            'fulfillmentShipDispatched',
            'fulfillmentShipFulfilled',
            'fulfillmentShipPrinted',
            'fulfillmentHospital',
        ];
        const customWarehouseRoutes = [
            'pickupCancelled',
            'pickupHospital',
            'pickupReady',
            'interOfficeCancelled',
            'interOfficeHospital',
            'interOfficeReady',
        ];
        const pickRoutes = ['fulfillmentShipPick', 'pickupPick'];
        const finalizedRoutes = ['pickupFinalized', 'interOfficeFinalized'];

        updateCustomGridData(app, skuRoutes, customGridAddSkuData);
        updateCustomGridData(app, customWarehouseRoutes, customGridDataWarehouseLabel);
        updateCustomGridData(app, pickRoutes, customPickGridConfig);
        updateCustomGridData(app, finalizedRoutes, customFinalizedGridConfig);
    },
};
